import { CaseStudy, SimulationEhr } from 'models/ui';
import { Box, ButtonClose } from 'components/common';
import { ELSButton, ELSFlex, ELSFlexItem } from 'components/common/els';
import AssignmentInfoView from './AssignmentInfoView';
import { AssignmentType } from 'models/enum';

export interface QuickViewPanelProps {
  activeTab: number;
  selectedContent: CaseStudy | SimulationEhr;
  onSelectClick: Function;
  onTabGroupClick: Function;
  onCloseSideBar: Function;
  onPreviewContent: Function;
  isBookOrganized: boolean;
  assignmentType: string;
}

const QuickViewPanel = (props: QuickViewPanelProps) => {
  const { id, patient, title } = props.selectedContent || {};
  const titleText = props.assignmentType === AssignmentType.CASE_STUDY ? 'Case Study' : 'Simulation EHR';
  if (!id) {
    return null;
  }
  return (
    <>
      <Box mt>
        <ButtonClose onClick={props.onCloseSideBar} />
      </Box>
      <Box mt2>
        <p>Quick view</p>
        <h2>{title}</h2>
      </Box>
      <Box mt2 className={`quick-view__patient-info ${props.assignmentType === AssignmentType.SIMULATION ? 'quick-view__increase-width' : ''}`}>
        <ELSFlex spaceBetween>
          <ELSFlexItem>
            <p>Patient name (Last, First)</p>
            <h4>{`${patient?.lastName}, ${patient?.firstName}`}</h4>
          </ELSFlexItem>
          <ELSFlexItem className="u-els-float-left u-els-text-right">
            <p>Hospital Floor</p>
            <h4>{patient?.hospitalFloor}</h4>
          </ELSFlexItem>
        </ELSFlex>
        <Box mt>
          <ELSButton className="u-els-margin-right" text={`Demo ${titleText}`} type="secondary" iconName="activity-online" onClick={props.onPreviewContent} />
          <ELSButton text={`Select this ${titleText}`} onClick={props.onSelectClick} />
        </Box>
      </Box>
      <AssignmentInfoView activeTab={props.activeTab} selectedContent={props.selectedContent} onTabGroupClick={props.onTabGroupClick} isBookOrganized={props.isBookOrganized} />
    </>
  );
};

QuickViewPanel.displayName = 'QuickViewPanel';
export default QuickViewPanel;
